exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_0421e9d{display:flex;align-items:center;font-size:16px;color:#333;color:var(--color-font-1);font-weight:700;margin-bottom:25px}.status_8633b38{padding:0 5px;border-radius:3px;font-size:12px;margin-left:10px;color:#f55555;background-color:rgba(245,108,108,.4)}", ""]);

// exports
exports.locals = {
	"title": "title_0421e9d",
	"status": "status_8633b38"
};